import './Line.css'

export function Line(){
    return(
        
        <div className="line-partners"> 

        </div>
       
    )
}